import * as React from 'react';
import { AgendaEventsListView } from './AgendaEventsListView';
import { DateRange } from 'owa-datetime-utils';
import { getDisplayDateRange } from '../selectors/agendaStoreSelectors';
import {
    getFolderIdByCalendarID,
    calendarFolderIdNeedsUpdate,
    calendarIsInCache,
    getAndUpdateActualFolderId,
} from '../selectors/calendarCacheSelectors';
import { getSelectedCalendars } from '../selectors/userConfigSelectors';
import { loadCalendarCache } from '../actions/internalActions';
import { observer } from 'mobx-react';

export interface AgendaEventsViewProps {
    dateRange: DateRange;
    scenarioId: string;
}

@observer
export class AgendaEventsView extends React.Component<AgendaEventsViewProps, {}> {
    componentDidMount() {
        // TODO VSO 44504: not all calendars are loading into calendars cache in the initialization agenda list view
        loadCalendarCache();
    }

    render() {
        const { dateRange, scenarioId } = this.props;
        return (
            <AgendaEventsViewInternal
                calendarIds={getSelectedCalendars().filter(calendarIsInCache)}
                dateRange={getDisplayDateRange(dateRange)}
                scenarioId={scenarioId}
            />
        );
    }
}

export interface AgendaEventsViewInternalProps {
    dateRange: DateRange;
    calendarIds: string[];
    scenarioId: string;
}

@observer
export class AgendaEventsViewInternal extends React.Component<AgendaEventsViewInternalProps, {}> {
    componentDidUpdate(prevProps: AgendaEventsViewInternalProps) {
        if (prevProps.calendarIds !== this.props.calendarIds) {
            this.props.calendarIds
                .filter(calendarFolderIdNeedsUpdate)
                .forEach(getAndUpdateActualFolderId);
        }
    }

    render() {
        const { calendarIds, dateRange, scenarioId } = this.props;
        const folderIds = calendarIds
            .filter(id => !calendarFolderIdNeedsUpdate(id))
            .map(getFolderIdByCalendarID);
        return (
            <AgendaEventsListView
                folderIds={folderIds}
                dateRange={dateRange}
                scenarioId={scenarioId}
            />
        );
    }
}
